import classNames from 'classnames';
import { useEffect, useState } from 'react';

type StepProgressProps = {
  steps: {
    fields: {
      title: {
        value: string;
      };
    };
  }[];
  activeStep: number;
};

const StepProgress = ({ steps, activeStep }: StepProgressProps) => {
  const [thumbWidth, setThumbWidth] = useState('0');
  useEffect(() => {
    const stepElement = document.querySelector('.steps-progress__step');
    if (stepElement) {
      const STEP_ELEMENT_WIDTH = stepElement.scrollWidth;
      const initialThumbWidth = STEP_ELEMENT_WIDTH / 2;
      setThumbWidth(`${STEP_ELEMENT_WIDTH * activeStep - initialThumbWidth}px`);
    }
  }, [activeStep]);

  return (
    <section className="mb-8">
      <div className="steps-progress">
        {steps.map((step, index) => (
          <div
            key={index}
            className={classNames({
              'steps-progress__step': true,
              active: activeStep === index + 1,
              completed: activeStep > index + 1,
            })}
          >
            <span className="steps-progress__number subheader-2">{index + 1}</span>
            <p className="subheader-1 text-center m-auto">{step.fields.title.value}</p>
          </div>
        ))}
      </div>
      <div className="progress-bar">
        <div className="progress-bar__thumb" style={{ width: thumbWidth }} />
      </div>
    </section>
  );
};

export default StepProgress;
